<template>
  <div id="qingyu">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'QingYu'
};
</script>

<style lang="less" scoped>
#qingyu {
  overflow: hidden;
  position: relative;
  width: 100%;
  // min-width: 320px;
  // max-width: 750px;
  height: 100vh;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/qingyu/App.vue